import React from "react";
import moment from "moment";
import { ChevronLeft, ChevronRight, Plus } from "lucide-react";
import { CALENDAR_ACCENT } from "./CalendarConstants";
import ViewSelector from "./ViewSelector";

const CalendarHeader = ({
  focusedDay,
  viewType,
  onPrevious,
  onNext,
  onToday,
  onAdd,
  onViewChanged,
  loading,
}) => {
  const getTitle = () => {
    const m = moment(focusedDay);
    switch (viewType) {
      case "month":
        return m.format("MMMM YYYY");
      case "week": {
        const weekStart = m.clone().startOf("isoWeek");
        const weekEnd = weekStart.clone().add(6, "days");
        if (weekStart.month() === weekEnd.month()) {
          return `${weekStart.format("D.")} - ${weekEnd.format("D. MMMM YYYY")}`;
        }
        return `${weekStart.format("D. MMM")} - ${weekEnd.format("D. MMM YYYY")}`;
      }
      case "day":
        return m.format("dddd, D. MMMM YYYY");
      default:
        return m.format("MMMM YYYY");
    }
  };

  return (
    <div style={{
      padding: 8,
      backgroundColor: "#fff",
      borderBottom: "1px solid #E0E0E0",
    }}>
      {/* Top row: navigation + actions */}
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: 4,
      }}>
        <button
          onClick={onPrevious}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 4,
            display: "flex",
            alignItems: "center",
            color: CALENDAR_ACCENT,
          }}
        >
          <ChevronLeft size={22} />
        </button>

        <div style={{
          flex: 1,
          textAlign: "center",
          fontSize: 17,
          fontWeight: "bold",
        }}>
          {getTitle()}
        </div>

        <button
          onClick={onNext}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 4,
            display: "flex",
            alignItems: "center",
            color: CALENDAR_ACCENT,
          }}
        >
          <ChevronRight size={22} />
        </button>

        <button
          onClick={onToday}
          style={{
            padding: "5px 10px",
            fontSize: 13,
            fontWeight: 500,
            color: "#616161",
            backgroundColor: "transparent",
            border: "1px solid #bdbdbd",
            borderRadius: 8,
            cursor: "pointer",
          }}
        >
          Heute
        </button>

        <button
          onClick={onAdd}
          style={{
            width: 36,
            height: 36,
            borderRadius: 8,
            backgroundColor: CALENDAR_ACCENT,
            color: "#fff",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Plus size={20} />
        </button>
      </div>

      {/* Loading bar */}
      {loading && (
        <div style={{
          height: 2,
          backgroundColor: CALENDAR_ACCENT,
          marginTop: 4,
          animation: "calLoadingPulse 1.5s infinite",
        }} />
      )}

      {/* View selector */}
      <div style={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
        <ViewSelector selected={viewType} onChanged={onViewChanged} />
      </div>
    </div>
  );
};

export default CalendarHeader;
